<template>
  <div>
    <header class="map-section-landing" v-scroll="onScroll">        
      <div class="landing-wrapper">
        <AppLayoutHeader />
        <v-container
          class="px-sm-8 py-0 pa-md-0 fill-height landing-message">
          <v-row no-gutters justify="center">
            <div              
              data-aos="fade-right"
              data-aos-ease ="ease"
              data-aos-duration="1000"
              data-aos-delay="100">
              <h1 class="text-hero text-center text--fes-blue mb-0 mr-4">
               Asia’s urban challenges are unique.
              </h1>
            </div>

            <div              
              data-aos="fade-left"
              data-aos-ease ="ease"
              data-aos-duration="1000"
              data-aos-delay="100">
              <h1 class="text-hero text-center text--fes-blue">
                They are also great opportunities
                <span class="text--fes-magenta">for sustainable change.</span>
              </h1>
            </div>            
          </v-row>           
        </v-container>
        <AppLayoutLinks :class="classes" />
      </div>
    </header>
    <slot />
  </div>
</template>

<script>
import AppLayoutLinks from '@/layouts/AppLayoutLinks'
import AppLayoutHeader from '@/layouts/AppLayoutHeader'
import { mapGetters } from 'vuex';

export default {
  name: "AppLayoutMap",
  components: {
    AppLayoutLinks, 
    AppLayoutHeader
  },
  computed: {
    ...mapGetters('contentPanel', ['panelState', 'mapInteractive']), 
  },
  data() {
    return {
      classes: 'header-navlinks header-navlinks--absolute text-nav-lg'
    }
  },
  mounted() {
    document.querySelector('.map-section-landing').style.height = '200vh';
  },
  methods: {
    onScroll (e) {
      var navlinks = document.querySelector('.header-navlinks').offsetHeight;
      var landing = document.querySelector('.landing-wrapper').offsetHeight;

      const offsetNav = landing - navlinks;
      const mapUI = document.querySelector('.map-ui-container');

      if (e.currentTarget.scrollY >= offsetNav) {
        this.classes = 'header-navlinks header-navlinks--fix header-navlinks--glass text-nav';  
        mapUI.style.opacity = 1;
        mapUI.style.visibility = 'visible';

        // fix the header
        document.querySelector('.landing-wrapper').style.height = '0px';
        document.querySelector('.map-section-landing').style.height = '0px'; 
        
        // style fixed header 
        document.querySelector('.landing-message').style.display = 'none';
        document.querySelector('.header-logo').style.display = 'none';
        document.querySelector('.landing-message').style.opacity = 0;
        document.querySelector('.header-logo').style.opacity = 0;

        // snap map interactive
        this.$store.dispatch('contentPanel/updateMapState', true);

      } else {
        this.classes = 'header-navlinks header-navlinks--absolute text-nav-lg';
        mapUI.style.opacity = 0;
        mapUI.style.visibility = 'hidden';    
        document.querySelector('.landing-message').style.display = 'flex';
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.landing-wrapper {
  height: calc(100vh - 144px);
  background: url("~@/assets/about/about-landing-bg.png");
  position: relative;
  z-index: 5;
  background: rgba(250, 250, 250, 0.72);
  // backdrop-filter: blur(10px);
  // -webkit-backdrop-filter: blur(10px);   
}
</style>
